import React from 'react';
import {useParams} from 'react-router-dom';

import {BackBar} from 'src/app/layout/BackBar';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {SupervisorApprovalForm} from 'src/app/tasks/SupervisorApprovalForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {useActionsBreadcrumbs} from '../hooks/useActionsBreadcrumbs';

const ViewActionSupervisorApprovalPage: React.FC = () => {
  const {taskId} = useParams();
  const {backBarProps} = useActionsBreadcrumbs({mode: 'supervisor-approval'});

  return (
    <ContentWrapper>
      <BackBar {...backBarProps} />
      {taskId && <SupervisorApprovalForm taskId={Number(taskId)} />}
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.ViewActionSupervisorApproval(':taskId'),
  element: <ViewActionSupervisorApprovalPage />,
  isPrivate: true,
});

export default ViewActionSupervisorApprovalPage;
